// 语言代码映射表
export const localeMappings = {
  // 完整格式到简短格式的映射
  fullToShort: {
    'zh_CN': 'zh',
    'zh_TW': 'zh-TW',
    'en_US': 'en',
    'ja_JP': 'ja',
    'ko_KR': 'ko',
    'fr_FR': 'fr',
    'de_DE': 'de',
    'es_ES': 'es'
  },
  // 简短格式到完整格式的映射
  shortToFull: {
    'zh': 'zh_CN',
    'zh-TW': 'zh_TW',
    'en': 'en_US',
    'ja': 'ja_JP',
    'ko': 'ko_KR',
    'fr': 'fr_FR',
    'de': 'de_DE',
    'es': 'es_ES'
  },
  // 浏览器语言代码到应用语言代码的映射
  browserToApp: {
    'zh-cn': 'zh',
    'zh-hans': 'zh',
    'zh-sg': 'zh',
    'zh-tw': 'zh-TW',
    'zh-hk': 'zh-TW',
    'en-us': 'en',
    'en-gb': 'en'
  }
} as const;

// 支持的语言列表
export const supportedLocales = ['zh', 'zh-TW', 'en', 'ja', 'ko', 'fr', 'de', 'es'] as const;

// 语言显示名称
export const localeNames = {
  'zh': '简体中文',
  'zh-TW': '繁體中文',
  'en': 'English',
  'ja': '日本語',
  'ko': '한국어',
  'fr': 'Français',
  'de': 'Deutsch',
  'es': 'Español'
} as const;

// 类型定义
export type SupportedLocale = typeof supportedLocales[number];
export type LocaleName = keyof typeof localeNames;

// 可用语言列表（用于UI显示）
export const availableLocales = supportedLocales.map(code => ({
  code,
  name: localeNames[code]
})); 